<template>
  <div>
    <el-dialog title="年终考核" :visible.sync="isVisible" @close="listDialogClose">
      <el-row>
        <el-col :span="24" class="layout-col">
          <el-card class="table-card" :body-style="{ padding: '0px' }">
            <div slot="header" class="table-card-header">
              <span>考核列表</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="
                  editFormData = {};
                  editDialogStatus = 1;
                "
                >新增</el-button
              >
            </div>
            <el-table
              :data="tableData"
              border
              highlight-current-row
              style="width: 100%"
              ref="table"
            >
              <el-table-column type="index" width="50" :index="lineNumber">
              </el-table-column>
              <!-- prop  对应列内容的字段名，也可以使用 property 属性 
                 label 属性来定义表格的列名
            -->
              <el-table-column
                prop="annual"
                label="年度"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="grade"
                label="考核评价"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
                :formatter = "levelFormat"
              >
              </el-table-column>
              <el-table-column
                prop="remarks"
                label="备注"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <i
                    class="el-icon-search"
                    title="查看"
                    @click="
                      editFormData = scope.row;
                      detailDialogStatus = 1;
                    "
                  ></i>
                  <i
                    class="el-icon-edit"
                    title="修改"
                    @click="
                      editData = scope.row;
                      DialogStatus = 2;
                    "
                  ></i>
                  <i
                    class="el-icon-delete"
                    title="删除"
                    @click="deleteTableData(scope.row)"
                  ></i>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="totalElements"
              @current-change="tablePaging"
            >
            </el-pagination>
          </el-card>
        </el-col>
        <el-col :span="12" class="layout-col"> </el-col>
      </el-row>
    </el-dialog>
    <!-- 添加模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="editDialogClose"
      v-if="editDialogStatus != 0"
    >
      <!-- <edit-form-builder :entityPropertys="entityPropertys" :formData="editFormData" :colsOfRow="editFormColsOfRow" :formStatus="editDialogStatus"></edit-form-builder> -->
      <el-form ref="xzyh" :model="form" :rules="insertRules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="年度" prop="annual">
              <el-date-picker type="year" placeholder="选择年度" v-model="form.annual" value-format="yyyy" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考核评价" prop="grade">
              <el-select v-model="form.grade" placeholder="请选择考核级别">
                <el-option label="优秀" value="1"></el-option>
                <el-option label="良好" value="2"></el-option>
                <el-option label="及格" value="3"></el-option>
                <el-option label="不及格" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input  type="textarea" v-model="form.remarks" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogStatus = 0">取 消</el-button>
        <el-button type="primary" @click="saveEditFormData">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="detailDialogClose"
      v-if="detailDialogStatus != 0"
    >
      <el-form ref="form" :model="editFormData" :disabled='edit' label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="年度">
              <el-input v-model="editFormData.annual"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考核评价">
               <el-input :value="editFormData.grade == 1 ? '优秀' : editFormData.grade == 2 ? '良好' : editFormData.grade == 3 ? '及格' : '不及格'"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="editFormData.remarks"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 修改模态框 -->
    <el-dialog
      title=""
      :visible="true"
      @close="DialogClose"
      v-if="DialogStatus !=0"
    >
      <el-form ref="xzyh" :rules="insertRules" :model="editData" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="年度" prop="annual">
              <el-date-picker type="year" placeholder="选择年度" v-model="editData.annual" value-format="yyyy" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考核级别" prop="grade">
              <el-select v-model="editData.grade" placeholder="请选择考核级别">
                <el-option label="优秀" value="1"></el-option>
                <el-option label="良好" value="2"></el-option>
                <el-option label="及格" value="3"></el-option>
                <el-option label="不及格" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input type="textarea" v-model="editData.remarks"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="DialogStatus = 0">取 消</el-button>
          <el-button type="primary" @click="updateEditFormData">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "table-list",
  data() {
    return {
      xzyh: {
      },
      edit:true,
      yhid:'',
      form: {
        userid:this.yhid,
        annual:'',
        grade:'',
        remarks:'',
        ljsc:''
      },
      isVisible: true,
      //列表数据
      tableData: [],
      totalElements: 0,
      pageNumber: 0,
      detailDialogStatus: 0, //控制模态框
      editFormColsOfRow: 2,
      editDialogStatus: 0,
      DialogStatus:0,
      editFormData: {},
      editData: {},
      detailTableColsOfRow: 2,
      //表单验证规则
      insertRules: {
        //每年只有一条考核，对年度进行限制
        annual: [
          {
            required: true,
            message: "请选择年度信息",
            trigger: ["blur", "change"],
          },
          { validator: this.isHava, trigger: ["blur", "change"] },
        ],
        grade: [
          {
            required: true,
            message: "请选择考核评价",
            trigger: ["blur", "change"],
          }
        ],
      },
    };
  },
  methods: {
    fetchTableData(id) {
      if(id){
        this.yhid = id
      }
      request({
        url: "/bjba/yhgl/getNdkhxx",
        method: "get",
        params: {
          page: this.pageNumber,
          size: 10,
          userid:this.yhid
        },
      })
        .then((response) => {
          const data = response.data;
          this.tableData = data.content;
          this.totalElements = data.totalElements;
          // this.$nextTick(() => {
          //   if (this.tableData.length > 0) {
          //     this.$refs.table.setCurrentRow(this.tableData[0])
          //   }
          // })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //保存用户信息
    saveEditFormData() {
      let formData ={}
      this.$set(this.form,'ljsc','0')
      this.$set(this.form,'userid',this.yhid)
      formData = this.form 
      console.log(this.form);

      this.$refs["xzyh"].validate((valid) => {
        if (!valid){
          console.log('error submit!!');
          return false;
        }
        request({ 
          url: "/bjba/yhgl/xzndkhxx",
          method: "post",
          data: formData,
        })
          .then((response) => {
            const data = response.data
            if (this.editDialogStatus === 1) {
              this.tableData.unshift(data); //将元素添加
              this.totalElements = this.totalElements + 1;
              this.$refs.table.setCurrentRow();
              // this.$nextTick(() => {
              //   this.$refs.table.setCurrentRow(this.tableData[0]);
              // });
            } else {
              this.tableData = this.tableData.map((item) => {
                return item.id === data.id ? data : item;
              });
            }
            this.form = {}
            this.editDialogStatus = 0;
            this.$message("操作成功");
          })
          .catch((error) => {
            console.log(error);
            this.$message("操作失败");
          });
      }) 
    },
    //更新用户信息
    updateEditFormData() {
      let formData ={}
      this.$set(this.editData,'ljsc','0')
      formData = this.editData
      console.log
      this.$refs["xzyh"].validate((valid) => {
        if (!valid){
          console.log('error submit!!');
          return false;
        }
      request({ 
        url: "/bjba/yhgl/xzndkhxx",
        method: "post",
        data: formData,
      })
        .then((response) => {
          this.fetchTableData()
          this.DialogStatus = 0;
          this.$message("修改成功");
        })
        .catch((error) => {
          console.log(error);
          this.$message("操作失败");
        });
      })
    },
    //删除亲属数据
    deleteTableData(row) {
      console.log(row);
      let data = row;
      this.$confirm("确定删除【" + row.annual +"年度"+ "】考核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$set(data, "ljsc", "1");
          request({
            url: "/bjba/yhgl/deleteNdkhxx",
            method: "PUT",
            data: data,
          })
            .then((response) => {
              this.fetchTableData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch((error) => {
              console.log(error);
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            });
        })
        .catch(() => {});
    },
    listDialogClose() {
      let close = false;
      this.$emit("closepop", close);
    },
    editDialogClose() {
      this.editDialogStatus = 0;
    },

    detailDialogClose() {
      this.detailDialogStatus = 0;
    },

    DialogClose() {
      this.DialogStatus = 0;
    },

    lineNumber(index) {
      return this.pageNumber * 10 + index + 1;
    },

    tablePaging(pageNumber) {
      this.pageNumber = pageNumber - 1;
      this.fetchTableData();
    },
    search() {
      this.fetchTableData();
    },
    levelFormat(row, column){
      if(row.grade == 1){
          return '优秀'
      }else if(row.grade == 2){
          return '良好'
      }else if(row.grade == 3){
          return '及格'
      }else if(row.grade == 4){
          return '不及格'
      }
    },
    isHava(rule, value, callback) {
      for(var i = 0,len = this.tableData.length ;i < len ; i++){
        console.log(this.tableData[i])
        console.log(this.form.annual)
        if(this.tableData[i].annual == this.form.annual){
          callback(new Error("本年度已考核，请勿重复考核"));
          return
        }
      }
      callback();
    }
  },
};
</script>
<style scoped>
.layout-col {
  text-align: center;
}
.search-input {
  width: 80%;
  margin: 5px;
}

.table-card-header {
  text-align: left;
}
.dialog-footer {
  text-align: center;
}
.el-icon-search,
.el-icon-edit,
.el-icon-delete {
  cursor: pointer;
}
</style>
